import cookie from 'js-cookie'

export const LOCALSTORAGE_KEY_SPACE = 'space'

export const SPACE = {
  PHARMEDIGROUP: 'pharmedigroup',
  INDUSTRY: 'industry',
} as const

export type Space = (typeof SPACE)[keyof typeof SPACE]

export const SPACE_DEFAULT: Space = SPACE.PHARMEDIGROUP

export const DEFAULT_SPACE_FOR_INDUSTRY_USER: Space = SPACE.INDUSTRY

// Etat module : source de verite cote client pour l'axe "space".
// Calque sur entityStore (cookie persistant + useSyncExternalStore).
let current: Space | undefined

type Listener = () => void
const listeners = new Set<Listener>()

const readCookie = (): Space | undefined => {
  if (typeof document === 'undefined') return undefined
  const value = cookie.get(LOCALSTORAGE_KEY_SPACE)
  return value ? (value as Space) : undefined
}

/**
 * Snapshot lu par useSyncExternalStore (client).
 * Priorite : etat module > cookie > defaut.
 */
export const getSpaceSnapshot = (): Space => current ?? readCookie() ?? SPACE_DEFAULT

/**
 * Snapshot deterministe cote serveur (anti-mismatch d'hydratation).
 * Le serveur ne lit ni l'etat module client ni le cookie navigateur : il
 * renvoie toujours `SPACE_DEFAULT` (ou la valeur seedee via initSpace lors du
 * render). Le client se resynchronise via le cookie au premier snapshot client.
 */
export const getSpaceServerSnapshot = (): Space => current ?? SPACE_DEFAULT

const notify = (): void => {
  listeners.forEach(listener => listener())
}

/**
 * Met a jour l'axe space courant, persiste le cookie et notifie les abonnes.
 */
export const setSpaceValue = (value: Space): void => {
  current = value
  cookie.set(LOCALSTORAGE_KEY_SPACE, value, {
    expires: 1,
  })
  notify()
}

/**
 * Seed initial (SSR -> render) sans reecrire le cookie.
 * N'ecrase pas une valeur deja choisie par l'utilisateur dans la session.
 */
export const initSpace = (value?: Space | null): void => {
  if (current === undefined && value) {
    current = value
    notify()
  }
}

export const subscribeSpace = (callback: Listener): (() => void) => {
  listeners.add(callback)
  return () => {
    listeners.delete(callback)
  }
}
